import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { CalendarContext } from ".";
import WFHWeekCalendar from "pages/WeekCalendarView/WFHWeekCalender";
import TabsList from "molecules/TabsList";
import { getMenuList, getUserRoleId } from "redux/selectors";

function WFHCalendar({ tabId, setTabId }) {
  const { tabBarExtraContent } = useContext(CalendarContext);

  const menuList = useSelector(getMenuList);
  const userRoleId = useSelector(getUserRoleId);

  let Menulist = menuList[userRoleId] || Object.values(menuList)[0] || menuList;
  Menulist = Array.isArray(Menulist) ? Menulist : [];

  const hasMyWfhAccess = Menulist?.some(
    (item) => item.key === "mywfh" && item.permission?.view
  );

  const hasMyTeamWfhAccess = Menulist?.some(
    (item) => item.key === "myteamwfh" && item.permission?.view
  );

  const hasAllWfhAccess = Menulist?.some(
    (item) => item.key === "allwfh" && item.permission?.view
  );

  const items = [
    hasMyWfhAccess && {
      id: "Mine",
      label: "Mine",
      component: <WFHWeekCalendar activeTab="Mine" />,
    },
    hasMyTeamWfhAccess && {
      id: "My Team",
      label: "My Team",
      component: <WFHWeekCalendar activeTab="My Team" />,
    },
    hasAllWfhAccess && {
      id: "All",
      label: "All",
      component: <WFHWeekCalendar activeTab="All" />,
    },
  ].filter(Boolean);

  const handleTabSelect = (key) => {
    setTabId(key);
  };

  return (
    <TabsList
      items={items}
      tabBarExtraContent={tabBarExtraContent}
      tabId={tabId}
      handleTabSelect={handleTabSelect}
    />
  );
}

export default WFHCalendar;